<mat-card appearance="outlined">
  <mat-card-title>Créer mon compte</mat-card-title>
  <form [formGroup]="form">
    @if (!nextStepSignup) {
      <div>
        @if (!isLoading) {
          <div>
            <p class="space">
              <mat-form-field>
                <mat-label>Email client In Extenso</mat-label>
                <input [(ngModel)]="login.username" formControlName="email" matInput>
                @if (form.get('email').hasError('required')) {
                  <mat-error>
                    L'email client In Extenso est requis
                  </mat-error>
                }
                @if (form.get('email').hasError('email')) {
                  <mat-error>
                    L'email client In Extenso doit être valide
                  </mat-error>
                }
              </mat-form-field>
            </p>
            <p class="space">
              <mat-form-field>
                <mat-label>Mot de passe</mat-label>
                <input [(ngModel)]="login.password" [type]="showPassword ? 'text' : 'password'" class="password_input"
                  formControlName="password" matInput>
                  <mat-icon (click)="clickShowPassword()" class="password_button">remove_red_eye</mat-icon>
                  @if (form.get('password').hasError('required')) {
                    <mat-error>
                      Le mot de passe est requis
                    </mat-error>
                  }
                  @if (form.get('password').hasError('minlength')) {
                    <mat-error>
                      Le mot de passe doit faire au minimum 8 caractères
                    </mat-error>
                  }
                </mat-form-field>
              </p>
              <p class="space">
                <mat-form-field>
                  <mat-label>Confirmation de mot de passe</mat-label>
                  <input [type]="showPasswordRepeat ? 'text' : 'password'" class="password_input"
                    formControlName="passwordConfirm" matInput>
                    <mat-icon (click)="clickShowPasswordRepeat()" class="password_button">remove_red_eye</mat-icon>
                    @if (form.get('passwordConfirm').hasError('required')) {
                      <mat-error>
                        La confirmation de mot de passe est requise
                      </mat-error>
                    }
                    @if (form.get('passwordConfirm').hasError('mismatch')) {
                      <mat-error>
                        Les 2 mots de passes ne correspondent pas
                      </mat-error>
                    }
                  </mat-form-field>
                </p>
                <p class="space_button">
          <button mat-button (click)="signup()" [disabled]="form.get('email').errors || form.get('password').errors
        || form.get('passwordConfirm').errors">Créer mon compte</button>
                </p>
              </div>
            }
          </div>
        }
        @if (nextStepSignup) {
          <div>
            @if (!isLoading) {
              <div>
                <p>Votre email est reconnu. Un code de confirmation vous a été envoyé. Veuillez le saisir ci-dessous</p>
                <mat-form-field>
                  <mat-label>Code de confirmation</mat-label>
                  <input [(ngModel)]="login.confirmationCode" formControlName="confirmationCode" matInput>
                  @if (form.get('confirmationCode').hasError('required')) {
                    <mat-error>
                      Le code de confirmation est requis
                    </mat-error>
                  }
                  @if (form.get('confirmationCode').hasError('minlength') || form.get('confirmationCode').hasError('maxlength')) {
                    <mat-error>
                      Le code de confirmation doit faire 6 caractères
                    </mat-error>
                  }
                </mat-form-field>
                <p class="space">
                  <mat-checkbox formControlName="validCgu"></mat-checkbox>
                  <span> En cochant cette case, j'atteste avoir lu et accepter les conditions d'utilisation décrites dans les
                    <a class="link_cgu" target="_blank" href="https://www.inextenso.fr/mentions-legales/">mentions légales</a>
                    et la <a class="link_cgu" target="_blank" href="https://www.inextenso.fr/politique-de-confidentialite/">politique de protection des données personnelles</a>
                  de la société In Extenso Opérationnel.</span>
                </p>
                <p class="space_button">
                  <button mat-button (click)="signupValidation()" [disabled]="form.get('confirmationCode').errors || form.get('validCgu').errors">Valider</button>
                </p>
              </div>
            }
          </div>
        }
        @if (isLoading) {
          <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
        }
      </form>
    </mat-card>
    <p class="link_resend">
      @if (nextStepSignup && !isLoading) {
        <button mat-button (click)="resendConfirmationCode()">Nouveau code par email</button>
      }
    </p>
